// Intl locale of each site language. Single source for `useDate` (client) and `helpers/server/date.js` (server).
// "ar": Gregorian calendar with Latin digits (also what chawk-bazar / ciseco format dates with).
const date_locates = {
  fa: "fa-IR",
  en: "en-US",
  ar: "ar-SA-u-ca-gregory-nu-latn",
};

export default date_locates;
